import { gql } from '@apollo/client'
import { smallProductFragment, productFragment } from 'Fragments'

const GET_COMPARE = gql`
  query compare($arguments: CompareProducts!, $pagination: Pagination!) {
    compare(arguments: $arguments, pagination: $pagination) {
      _cache
      product {
        ...product
      }
      products {
        ...smallProduct
      }
    }
  }
  ${productFragment}
  ${smallProductFragment}
`

export default GET_COMPARE
